import { render, staticRenderFns } from "./index.vue?vue&type=template&id=926d541c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppLiteVideo: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppLiteVideo.vue').default})
